import { render, staticRenderFns } from "./phoneNumber.vue?vue&type=template&id=a03f53dc&"
import script from "./phoneNumber.vue?vue&type=script&lang=js&"
export * from "./phoneNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports